import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Centraliza exibição do modal de sessão expirada e logout forçado.
 * Usado pelo idle timer, interceptor JWT (556) e AuthGuard.
 *
 * Utiliza modal DOM nativo (não depende de NbDialogService / nb-layout)
 * para funcionar mesmo quando o layout Nebular não está disponível.
 */
@Injectable({
  providedIn: 'root',
})
export class SessionExpiryService {

  private modalAberto = false;

  constructor(
    private router: Router,
  ) {}

  /**
   * Exibe o modal de sessão expirada (somente uma vez por ciclo).
   * Modal bloqueante renderizado diretamente no DOM.
   */
  showSessionExpiredModal(): void {
    if (this.modalAberto) {
      return;
    }
    this.modalAberto = true;
    sessionStorage.setItem('actsit', '005');

    const overlay = document.createElement('div');
    overlay.id = 'sessao-expirada-overlay';
    overlay.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
      background: rgba(0, 0, 0, 0.6); z-index: 99999;
      display: flex; align-items: center; justify-content: center;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    `;

    overlay.innerHTML = `
      <div style="
        background: #fff; border-radius: 12px; max-width: 420px; width: 90%;
        box-shadow: 0 20px 60px rgba(0,0,0,0.3); overflow: hidden;
        animation: fadeInUp 0.3s ease-out;
      ">
        <div style="
          background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
          color: #fff; padding: 1rem 1.5rem;
          display: flex; align-items: center; gap: 0.75rem;
        ">
          <span style="font-size: 1.25rem;">⏱</span>
          <h4 style="margin: 0; font-size: 1.25rem; font-weight: 600;">Sessão encerrada</h4>
        </div>
        <div style="padding: 2rem 1.5rem; text-align: center;">
          <div style="margin-bottom: 1.25rem;">
            <img
              src="assets/images/clock-red.png"
              alt="Sessão expirada"
              style="width: 7rem; height: auto; display: block; margin: 0 auto;
                     filter: drop-shadow(0 4px 8px rgba(0,0,0,0.12));
                     transform-origin: top center;
                     animation: swing-suave 2.8s ease-in-out infinite;"
            />
          </div>
          <p style="font-size: 1rem; color: #2c3e50; margin: 0 0 0.5rem;">
            Sua sessão expirou por segurança.
          </p>
          <p style="font-size: 0.875rem; color: #7f8c8d; margin: 0 0 1.5rem;">
            Para continuar, faça login novamente. Seus dados não salvos podem ter sido perdidos.
          </p>
          <button id="sessao-expirada-btn" style="
            width: 100%; padding: 0.75rem 1rem; border: none; border-radius: 6px;
            background: linear-gradient(135deg, #6fc8f0 0%, #4ba8d4 100%);
            color: #fff; font-size: 1rem; font-weight: 600; cursor: pointer;
            transition: opacity 0.2s;
          ">
            Ir para o login
          </button>
        </div>
      </div>
      <style>
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes swing-suave {
          0%, 100% { transform: rotate3d(0, 0, 1, 0deg); }
          15% { transform: rotate3d(0, 0, 1, 8deg); }
          30% { transform: rotate3d(0, 0, 1, -5deg); }
          45% { transform: rotate3d(0, 0, 1, 3deg); }
          60% { transform: rotate3d(0, 0, 1, -2deg); }
          75% { transform: rotate3d(0, 0, 1, 1deg); }
        }
        #sessao-expirada-btn:hover { opacity: 0.9; }
      </style>
    `;

    document.body.appendChild(overlay);

    const btn = document.getElementById('sessao-expirada-btn');
    if (btn) {
      btn.addEventListener('click', () => {
        this.modalAberto = false;
        overlay.remove();
        this.clearSessionAndGoToLogin();
      });
    }
  }

  /**
   * Limpa dados de sessão e redireciona para login (mesmo fluxo do botão Sair do header).
   */
  clearSessionAndGoToLogin(): void {
    sessionStorage.removeItem('actsit');
    sessionStorage.removeItem('portal');
    sessionStorage.removeItem('uid');
    sessionStorage.removeItem('x');
    this.router.navigate(['/pages/authLogin/login']).then(() => {
      window.location.reload();
    });
  }
}
